// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"c3b6f2b2","257":"39e88da5","348":"6a2b8b12","565":"474cdd1f","634":"64c12c4a","666":"7b1e56d7","871":"05eaffd3","916":"454c4ffc"}[chunkId] + ".chunk.js";
};